import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0.209961 0.589966C0.719961 0.859966 1.11995 1.26987 1.44995 1.73987C1.77995 2.19987 2.0099 2.73994 2.1499 3.30994C2.2799 3.87994 2.2799 4.48993 2.1499 5.04993C2.0399 5.61993 1.70994 6.13992 1.30994 6.53992C1.33994 5.95992 1.40987 5.46997 1.36987 4.96997C1.33987 4.47997 1.29992 3.99991 1.16992 3.52991C0.969922 2.56991 0.599961 1.64997 0.209961 0.589966Z"
        fill={outline}
      />
    </g>
  )
}
